import { Client } from '../../../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { Produktionsabschnitt } from '../../../../../../projects/kiene-core/src/lib/components/stammdaten/vvvo/classes/betriebsart';

export class GruppeDialogInput {
    kunde: Client;
    einstalldatumAusblenden: boolean;
    nameVorschlag: string;
    produktionsabschnitt: Produktionsabschnitt;
    produktionsabschnitt_id: number;
    einstallDatum: Date;
    einstallGewicht: number;
    abteil: string;
    stall: string;
    bezeichnung: string;
    gruppe_id: number;
    vvvo: string;

    constructor(kunde: Client, einstalldatumAusblenden: boolean, nameVorschlag: string) {
        this.kunde = kunde;
        this.einstalldatumAusblenden = einstalldatumAusblenden;
        this.nameVorschlag = nameVorschlag;
    }
}
